import { useTranslation } from 'react-i18next';
import { categories, mainSiteUrl } from '@/mocks/categories';

const groupMap: Record<string, 'footwear' | 'apparel' | 'accessories' | 'other'> = {
  shoes: 'footwear',
  hoodies: 'apparel',
  tshirts: 'apparel',
  jackets: 'apparel',
  pants: 'apparel',
  headwear: 'accessories',
  sets: 'apparel',
  underwear: 'apparel',
  jersey: 'apparel',
  accessories: 'accessories',
  bags: 'accessories',
  belts: 'accessories',
  perfumes: 'other',
  other: 'other',
};

const sampleKeys = ['shoes', 'hoodies', 'tshirts', 'accessories', 'bags'];
const sampleTypes = ['Profile', 'Guide', 'Resource', 'Guide', 'Resource'];

export default function SpreadsheetSection() {
  const { t } = useTranslation();

  return (
    <section id="spreadsheet" className="bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <h2 className="font-heading text-2xl font-bold text-stone-900 md:text-3xl">
              {t('spreadsheet.title')}
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-stone-500 md:text-base">
              {t('spreadsheet.body')}
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-emerald-600 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-emerald-700"
            >
              {t('spreadsheet.cta')}
            </a>
          </div>

          <div className="overflow-hidden rounded-lg border border-stone-200">
            <div className="overflow-x-auto">
              <table className="w-full min-w-[520px] text-left text-sm">
                <thead>
                  <tr className="bg-stone-50 text-xs uppercase tracking-wide text-stone-500">
                    <th className="px-4 py-3 font-medium">{t('spreadsheet.colCreator')}</th>
                    <th className="px-4 py-3 font-medium">{t('spreadsheet.colCategory')}</th>
                    <th className="px-4 py-3 font-medium">{t('spreadsheet.colType')}</th>
                    <th className="px-4 py-3 font-medium">{t('spreadsheet.colInfo')}</th>
                    <th className="px-4 py-3 font-medium">{t('spreadsheet.colUpdated')}</th>
                  </tr>
                </thead>
                <tbody>
                  {sampleKeys.map((key, i) => {
                    const cat = categories.find((c) => c.key === key)!;
                    const group = groupMap[key] || 'other';
                    return (
                      <tr key={key} className="border-t border-stone-100">
                        <td className="whitespace-nowrap px-4 py-3 font-medium text-stone-800">
                          {t(`categories.${key}`)}
                        </td>
                        <td className="whitespace-nowrap px-4 py-3 text-stone-500">
                          {t(`spreadsheet.group.${group}`)}
                        </td>
                        <td className="whitespace-nowrap px-4 py-3 text-stone-500">
                          {t(`spreadsheet.rowType${sampleTypes[i]}`)}
                        </td>
                        <td className="whitespace-nowrap px-4 py-3">
                          <a
                            href={cat.url}
                            target="_blank"
                            rel="noopener nofollow"
                            className="whitespace-nowrap text-sm font-medium text-emerald-600 hover:text-emerald-700"
                          >
                            {t('spreadsheet.view')}
                          </a>
                        </td>
                        <td className="whitespace-nowrap px-4 py-3">
                          <span className="inline-flex items-center gap-1.5 text-emerald-600">
                            <span className="flex h-4 w-4 items-center justify-center text-sm">
                              <i className="ri-checkbox-circle-fill"></i>
                            </span>
                            <span className="text-xs text-stone-400">{t('spreadsheet.colUpdated')}</span>
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}